import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'stripe-dashboard',
  templateUrl: './stripe-dashboard.component.html',
  styleUrls: ['./stripe-dashboard.component.sass']
})
export class StripeDashboardComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/demo/stripe-dashboard/stripe-dashboard.component.ts